import { useContext } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import genericStyles from "../../Styles/genericStyles.module.css";
import { DrawerStateContext } from "../../Context/DrawerStateContext";
import { isTablet } from "../../Utils/Utils";
import { NewTaskButtonProps } from "../../Utils/Types";
import { Button, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function NewTaskButton(props: NewTaskButtonProps) {
  const drawerStateContext = useContext(DrawerStateContext);

  /**
   *
   */
  const handleChangeDrawerOpen = () => {
    drawerStateContext.setOpen(true);
  };

  return (
    <>
      <Button
        startIcon={<AddCircleIcon />}
        onClick={handleChangeDrawerOpen}
        size="large"
        color="primary"
        className={`${genericStyles.newTaskButton} ${props.style}`}
        variant="contained"
      >
        <Typography sx={{ fontWeight: "bold" }}>
          {isTablet() ? Vocabulary.task : Vocabulary.newTask}
        </Typography>
      </Button>
    </>
  );
}
